import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ExerciseForm from "../../components/forms/ExerciseForm";
import useGetExerciseDetails from "../../hooks/api/exercise/useGetExerciseDetails";
import BasePage from "../common/BasePage";

type Params = {
  exerciseId: string;
};

export default function EditExercisePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { exerciseId } = useParams<Params>();
  const {
    data: exercise,
    isLoading,
    isError,
    refetch,
  } = useGetExerciseDetails(exerciseId ?? "");

  const onSuccess = useCallback(() => {
    navigate("./../..");
    toast({
      title: t("edit_exercise_page.exercise_updated"),
      description: t("edit_exercise_page.exercise_updated_message"),
      status: "success",
      isClosable: true,
    });
  }, [navigate, t, toast]);

  const onError = useCallback(() => {
    toast({
      title: t("edit_exercise_page.exercise_error"),
      description: t("edit_exercise_page.exercise_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage
      title={t("edit_exercise_page.edit_exercise")}
      isLoading={isLoading}
      hasError={isError}
      retry={refetch}
    >
      <ExerciseForm
        exercise={exercise}
        onSuccess={onSuccess}
        onError={onError}
      />
    </BasePage>
  );
}
